import React, { Component } from 'react';
import { connect } from 'react-redux'
import { questionsByCategorySortedSelector } from '../../../modules/questions';
import QuestionForm from './QuestionForm'
import { Pagination } from 'antd';
import {cloneDeep, difference, isEqual} from 'lodash';
import { checkedCategoriesIdsSelector } from '../../../modules/categories';

class QuestionsPagination extends Component {
	constructor(props) {
		super(props)
		this.state = {
			questions_data: props.questions,
			pageSize: 10,
			currentPage: 1,
			checkedCategories: props.checkedCategories,
			questions: this.paginate(props.questions, 10, 1),
		}

		this.refEndEl = React.createRef();
	}

	scrollToBottom = () => {
		if(this.refEndEl.current){
			this.refEndEl.current.scrollIntoView({ behavior: "smooth" });
		}
	}

	componentDidMount(){
		window.goToLastPage = this.goToLastPage;
	}

	goToLastPage = () => {
		let {currentPage} = this.state;
		currentPage = Math.ceil(this.props.questions.length/this.state.pageSize);
		this.setState({
			questions_data: this.props.questions,
			questions: this.paginate(this.props.questions, this.state.pageSize, currentPage),
			currentPage
		});
		this.scrollToBottom();
	}


	componentWillReceiveProps(nextProps){

		const newIds = nextProps.questions.map(i => i.id);
		const oldIds = this.state.questions_data.map(i => i.id);
    console.log("🚀 ~ file: QuestionsPagination.js ~ line 48 ~ QuestionsPagination ~ componentWillReceiveProps ~ newIds", newIds, oldIds)

		let {currentPage} = this.state;

   
		if(!isEqual(nextProps.checkedCategories, this.state.checkedCategories)){
      this.setState({
				currentPage: 1,
				checkedCategories: nextProps.checkedCategories,
				questions_data: nextProps.questions,
				questions: this.paginate(nextProps.questions, this.state.pageSize, 1),
			})
		} else {
			if(!isEqual(newIds, oldIds)){
				console.log('test+++')
				this.setState({
					questions_data: nextProps.questions,
					questions: this.paginate(nextProps.questions, this.state.pageSize, currentPage),
				})
			}
	
			if(nextProps.showNewForm != this.props.showNewForm){
				console.log('test2222+++')
				this.setState({
					currentPage: Math.ceil(( nextProps.showNewForm ? nextProps.questions.length + 1 : nextProps.questions.length)/this.state.pageSize),
					questions: this.paginate(nextProps.questions, this.state.pageSize, Math.ceil((nextProps.showNewForm ? nextProps.questions.length + 1 : nextProps.questions.length)/this.state.pageSize))
				})
			}
		}
	}

	onShowSizeChange = (current, pageSize) => {
		this.setState({
			questions: this.paginate(this.state.questions_data, pageSize, current),
			pageSize,
			currentPage: current
		})
	}

	paginate = (array, page_size, page_number) => {
		if(page_number == 0){
			return cloneDeep(array).slice(0, page_size);
		}
  	--page_number;
		return cloneDeep(array).slice(page_number * page_size, (page_number + 1) * page_size);
	}

	scrollToTop(scrollDuration) {
    var scrollStep = -window.scrollY / (scrollDuration / 15),
        scrollInterval = setInterval(function(){
        if ( window.scrollY != 0 ) {
            window.scrollBy( 0, scrollStep );
        }
        else clearInterval(scrollInterval); 
    },15);
	}

  render() {
		const {questions, questions_data, pageSize, currentPage } = this.state;
    const {showNewForm} = this.props;
    if (!questions_data.length && !showNewForm) return null;
		
    return (
        <div style={{ marginTop: '1.5rem', marginBottom: '1.5rem'}}>
					<Pagination
                showSizeChanger
                onShowSizeChange={this.onShowSizeChange}
								total={showNewForm ? questions_data.length + 1 : questions_data.length}
								pageSizeOptions={['5', '10', '20', '50']}
								pageSize={pageSize}
								current={currentPage}
								onChange={(page, pageSize) => {
									 
									this.setState({
										questions: this.paginate(this.state.questions_data, pageSize, page),
										pageSize,
										currentPage: page,
									}, () => {
										this.scrollToTop(500);
									})
								}}
            />
            {questions.map((question, index) => <div key={'item-question-'+ question.id}>
                <QuestionForm
                  questionId = {question.id}
                />
						</div>)}
						{this.props.children}
            <Pagination
                showSizeChanger
                onShowSizeChange={this.onShowSizeChange}
								total={showNewForm ? questions_data.length + 1 : questions_data.length}
								pageSizeOptions={['5', '10', '20', '50']}
								pageSize={pageSize}
								current={currentPage}
								onChange={(page, pageSize) => {
									 
									this.setState({
										questions: this.paginate(this.state.questions_data, pageSize, page),
										pageSize,
										currentPage: page,
									}, () => {
										this.scrollToTop(500);
									})
								}}
            />
						 <div style={{ float:"left", clear: "both" }}
							ref={this.refEndEl}>
						</div>
        </div>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
		questions : questionsByCategorySortedSelector(state),
		checkedCategories: checkedCategoriesIdsSelector(state),
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionsPagination)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionsPagination.js